module.exports = __webpack_public_path__ + "static/media/disco.386bc196.jpg";